var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "apple",
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_475",
    "data-name": "Group 475"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2248",
    "data-name": "Path 2248",
    d: "M56.25,75H18.75A18.751,18.751,0,0,1,0,56.251V18.75A18.751,18.751,0,0,1,18.749,0h37.5A18.75,18.75,0,0,1,75,18.75v37.5A18.75,18.75,0,0,1,56.25,75",
    transform: "translate(0 0)",
    fill: "#2d2d2d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2249",
    "data-name": "Path 2249",
    d: "M35.789,18H57.263c5.716,0,10.43-3.754,10.723-8.539S64.047.536,58.361.046C58,.029,57.634,0,57.263,0H19.088C8.547,0,0,7.163,0,16V48C0,31.432,16.023,18,35.789,18",
    transform: "translate(0 0)",
    fill: "#464646",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2250",
    "data-name": "Path 2250",
    d: "M48,32A16,16,0,1,0,64,48V16A16,16,0,0,1,48,32",
    transform: "translate(11 11)",
    fill: "#141414",
    fillRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2251",
    "data-name": "Path 2251",
    d: "M39.069,12.212a7.792,7.792,0,0,1-2,5.11,7.132,7.132,0,0,1-4.965,2.8.7.7,0,0,1-.719-.7h-.01A8.007,8.007,0,0,1,33.5,14.255a8.164,8.164,0,0,1,2.581-1.937,8.428,8.428,0,0,1,2.232-.755.657.657,0,0,1,.756.649ZM46.116,39.94a19.825,19.825,0,0,1-1.963,3.53,17.945,17.945,0,0,1-2.529,3.057,4.91,4.91,0,0,1-3.25,1.432,8.151,8.151,0,0,1-3-.717,8.614,8.614,0,0,0-3.233-.715,8.907,8.907,0,0,0-3.324.715A8.952,8.952,0,0,1,25.942,48a4.621,4.621,0,0,1-3.324-1.47,18.8,18.8,0,0,1-2.645-3.165,21.881,21.881,0,0,1-2.8-5.556A20.346,20.346,0,0,1,16,31.183a12.094,12.094,0,0,1,1.588-6.327,9.322,9.322,0,0,1,3.326-3.364,8.947,8.947,0,0,1,4.5-1.269,10.578,10.578,0,0,1,3.478.81,11.188,11.188,0,0,0,2.759.811,16.473,16.473,0,0,0,3.059-.956,10.117,10.117,0,0,1,4.158-.738,9.569,9.569,0,0,1,5.265,1.891,1.933,1.933,0,0,1,.059,2.919A7.451,7.451,0,0,0,41.7,30.78a7.707,7.707,0,0,0,2.531,5.808,8.524,8.524,0,0,0,1.145.917,1.986,1.986,0,0,1,.73,2.423c.012.007.011.01.009.012Z",
    transform: "translate(5.216 4.612)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleLogo);
export default __webpack_public_path__ + "static/media/appleLogo.c1580bfb65bed811b929605512009302.svg";
export { ForwardRef as ReactComponent };